import { ParameterType } from '@/study-search/enums';

import { Filter } from '../../Filter';
import { IIndexation } from '../../../../interfaces';
import { FilterKey } from '@studyportals/search-filters/server-side';

export class ContinentFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.CONTINENT, ParameterType.CONTINENT, []);
	}

	public canBeIndexed(): boolean {
		return this.values.length === 1;
	}
}
